import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Spinner from './Spinner';

const PrivateRoute = () => {
  const { isAuthenticated, loading } = useAuth();

  // Show centered spinner while verifying authentication
  if (loading) {
    return <Spinner size="lg" text="Verifying authentication..." centered />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;